import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { UsersService } from 'src/app/options/users/users.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  role: string = "";

  constructor(private router: Router, private localStorage: LocalStorageService,
    private userService: UsersService) {
    this.role = this.localStorage.retrieve("userInfo").role;
  }

  ngOnInit(): void {
    this.getUserById();
    if (this.role == "Admin") {
      this.router.navigate(["./master/cards/paymentrequests"]);
    }
  }


  getUserById() {
    var userId = this.localStorage.retrieve("userInfo").userId;

    this.userService.getUserById(userId).subscribe(data => {
      console.log(data);
    }, error => {
      if (error.status == 401) {

        this.router.navigate(['']);
      }
    })
  }

}
